export default {
  getMedicalDevice: (state) => state.medicalDevice,
};
